import { useEffect, useState } from 'react';

export const useModalSizingHelper = () => {
  const [modalStyles, setModalStyles] = useState({});
  useEffect(() => {
    const updateModalStyles = () => {
      if (window.innerWidth <= 768) {
        setModalStyles({
          '--w-modal-height': '100%',
          '--w-modal-max-height': '100%',
          '--w-modal-width': '100%',
        });
      } else {
        setModalStyles({
          '--w-modal-height': '100%',
          '--w-modal-width': '60%',
          alignItems: 'center',
        });
      }
    };

    updateModalStyles();
    window.addEventListener('resize', updateModalStyles);

    return () => {
      window.removeEventListener('resize', updateModalStyles);
    };
  }, []);

  return modalStyles;
};
